<template>
    <transition name="el-fade-in">
        <div class="all" v-show="show">
            <div class="title">{{ name || "Article" }}</div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/article-list' }"
                    >article list</el-breadcrumb-item
                >
                <el-breadcrumb-item>{{
                    name || "change article"
                }}</el-breadcrumb-item>
            </el-breadcrumb>
            <page-editer
                :modelData.sync="data"
                :render="renderData"
                :handlerSave="Save"
                :handlerDelete="Delete"
                :handleLoad="Loaded"
            >
              <template slot-scope="scope" slot="colorShow">
                <div :style="`background-color:${data[scope.data.modelName]};height:30px;width:30px`"></div>
              </template>
            </page-editer>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            show: false,
            renderData: [
                {
                    key: "Name",
                    type: "input",
                    modelName: "name",
                    must: true,
                },
                {
                    key: "Description",
                    type: "textarea",
                    modelName: "description",
                    must: true,
                },
                {
                    key: "Cover Image",
                    type: "image",
                    modelName: "coverImageUrl",
                    must: true,
                },
                {
                    key: "Detail Image",
                    type: "image",
                    modelName: "detailImageUrl",
                    must: true,
                },
                {
                    key: "Type",
                    type: "select",
                    modelName: "type",
                    change:(val) => {
                      console.log(val)
                      if(val === 'Skincare'){
                        this.data.color = '#CCD3C1'
                      }
                      if(val === 'Makeup'){
                        this.data.color = '#B9C6E7'
                      }
                      if(val === 'Inner Beauty'){
                        this.data.color = '#A3DCFD'
                      }
                      if(val === 'Healthy Diet'){
                        this.data.color = '#D3C1D0'
                      }
                      if(val === 'Face Yoga'){
                        this.data.color = '#F6A7BA'
                      }
                    },
                    options:this.$store.state.optionBase.articleType,
                    uploadLabel:true,
                    must: true,
                },
                {
                    key: "color",
                    type: "slot",
                    slotName:'colorShow',
                    modelName: "color",
                },
                {
                    key: "Article",
                    type: "richText",
                    modelName: "article",
                    must: true,
                },
                {
                    key: "Reference",
                    type: "textarea",
                    modelName: "reference",
                },
            ],
            data: {
                name: "",
                description: "",
            },
        };
    },
    methods: {
        Save() {
            let uploadData = this.$deepCopy(this.data);
            this.renderData.some((item) => {
                // 多选数组转字符串数组
                if (item.type === "selects" && this.data[item.modelName]) {
                    uploadData[item.modelName] = this.data[item.modelName].toString();
                }
            });
            this.$request(
                "/manage/article/save",
                uploadData,
                (res) => {
                    if (res.data.code === 200) {
                        this.$message({
                            message: "save success",
                            type: "success",
                        });
                        this.$router.push('/article-list')
                    }
                },
                "post",
                true
            );
        },
        Delete() {
            this.$confirm("Confirm delete？", "", { type: "warning" }).then(() => {
                this.$request(
                    `/manage/article/del/${this.$route.query.id}`,
                    {},
                    (res) => {
                        if (res.data.code === 200) {
                            this.$message({
                                message: "delete success",
                                type: "success",
                            });
                            this.$router.go(-1);
                        }
                    }
                );
            });
        },
        Loaded() {
        this.show = true;
        if (this.$route.query.id && this.$route.query.id != "add") {
            this.$request(
                `/manage/article/detail/${this.$route.query.id}`,
                {},
                (res) => {
                    let data = res.data.data;
                    this.renderData.some((item) => {
                        if (item.type === "selects" && data[item.modelName]) {
                            data[item.modelName] = data[item.modelName].split(",");
                        }
                    });
                    this.data = data;
                },
                "get"
            );
        }
    },    
    },

};
</script>

<style scoped>
.all {
    box-sizing: border-box;
    padding: 0 40px;
    text-align: left;
    font-size: 13px;
}
.title {
    font-size: 24px;
    line-height: 50px;
}
.el-breadcrumb {
    height: 20px;
    line-height: 20px;
    margin-top: 30px;
}
</style>